import logoLight from '../../../assets/images/logo_light.svg';
import logoDark from '../../../assets/images/logo_dark.svg';

/**
 * Theme-aware logo that switches between light and dark variants.
 * Use `forceDark` for always-dark contexts like the landing page.
 */
export default function Logo({ className = 'h-8', forceDark = false }) {
  if (forceDark) {
    return <img src={logoDark} alt="StudyFit" className={className} />;
  }

  return (
    <>
      <img src={logoLight} alt="StudyFit" className={`${className} block dark:hidden`} />
      <img src={logoDark} alt="StudyFit" className={`${className} hidden dark:block`} />
    </>
  );
}
